import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export async function createTailoredCopy({ definition, scheduleNodeId, treeId }) {
    return mutate(
        gql`
            mutation createTailoredCopy($definition: ScheduleCreator!, $scheduleNodeId: String!, $treeId: String!) {
                createTailoredCopy(definition: $definition, scheduleNodeId: $scheduleNodeId, treeId: $treeId)
            }
        `,
        { definition, scheduleNodeId, treeId },
        { returns: "createTailoredCopy" }
    )
}
